<script>
  import Dashboard from "$lib/assets/imgs/Dashboard@2x.webp";
  import { onMount } from "svelte";

  let words = ["Small biz", "Website", "SME", "Enterprise"];
  let currentWord = 0;
  let displayText = "";

  onMount(() => {
    function typeWriter() {
      const targetWord = words[currentWord];
      let charIndex = 0;

      function type() {
        displayText = targetWord.substring(0, charIndex++);
        if (charIndex <= targetWord.length) {
          setTimeout(type, 100);
        } else {
          setTimeout(erase, 1500);
        }
      }

      function erase() {
        displayText = targetWord.substring(0, charIndex--);
        if (charIndex >= 0) {
          setTimeout(erase, 50);
        } else {
          currentWord = (currentWord + 1) % words.length;
          setTimeout(typeWriter, 500);
        }
      }

      type();
    }

    typeWriter();
  });
</script>

<section class="mt-8 md:mt-16 px-4">
  <!-- Headline with typewriter -->
  <div class="text-center mb-10">
    <h1
      class="text-3xl md:text-4xl lg:text-6xl font-extrabold text-gray-900 leading-tight"
    >
      Add Full E-commerce to your
      <br class="hidden md:block" />
      <span
        class="text-green-500 inline-block min-w-[120px] md:min-w-[200px] text-left typing-cursor"
      >
        {displayText}
      </span>
    </h1>
    <p class="text-gray-500 text-lg md:text-xl mt-4 max-w-2xl mx-auto">
      Everything you need to sell online — products, orders, analytics, and
      payments — all in one platform.
    </p>
    <div class="mt-8 flex items-center justify-center gap-4 flex-wrap">
      <a
        href="/apply"
        class="inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-bold text-lg px-8 py-4 rounded-full transition-all duration-200 shadow-lg hover:shadow-xl hover:scale-105"
      >
        Apply to Join Free
        <svg
          class="w-5 h-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M17 8l4 4m0 0l-4 4m4-4H3"
          />
        </svg>
      </a>
      <a
        href="#pricing"
        class="inline-flex items-center gap-2 border-2 border-gray-200 hover:border-green-500 text-gray-700 hover:text-green-600 font-semibold text-lg px-8 py-4 rounded-full transition-all duration-200"
      >
        View Pricing
      </a>
    </div>
  </div>

  <!-- Hero card with dashboard preview -->
  <div class="container mx-auto">
    <div
      class="w-full overflow-hidden rounded-2xl shadow-2xl flex flex-wrap lg:flex-nowrap bg-white"
    >
      <!-- Left text panel -->
      <div
        class="lg:w-5/12 p-8 md:p-12 lg:p-16 flex flex-col justify-center bg-gradient-to-br from-white to-gray-50"
      >
        <div
          class="inline-flex items-center gap-2 bg-green-100 text-green-700 text-xs font-bold px-3 py-1.5 rounded-full w-fit mb-5 uppercase tracking-wider"
        >
          All-in-one Platform
        </div>
        <h2 class="text-2xl lg:text-3xl font-bold text-gray-900 leading-tight">
          Meet UzaKitu.
          <br />
          <span class="text-green-500">An online helper for your business</span>
        </h2>
        <p class="text-gray-500 mt-4 leading-relaxed">
          Manage products, track orders, analyze traffic, and process payments —
          all from one beautiful dashboard.
        </p>
        <div class="mt-8">
          <a
            href="/apply"
            class="inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-semibold px-6 py-3 rounded-full transition-all duration-200 shadow-md hover:shadow-lg"
          >
            Apply Now
            <svg
              class="w-4 h-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </a>
        </div>
      </div>
      <!-- Right image panel -->
      <div
        class="lg:w-7/12 p-6 md:p-8 bg-green-500 flex items-center justify-center"
      >
        <img
          class="object-contain rounded-lg shadow-xl max-w-full"
          src={Dashboard}
          alt="Uzakitu Dashboard Preview"
          loading="eager"
        />
      </div>
    </div>
  </div>
</section>

<style>
  .typing-cursor::after {
    content: "|";
    animation: blink 0.8s infinite;
    font-weight: 100;
  }

  @keyframes blink {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
  }
</style>
